import CityPageTemplate from "../city-template/CityPageTemplate";
import { westbrookConfig } from "./data";

export default function WestbrookPage() {
  return <CityPageTemplate config={westbrookConfig} />;
}